import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table: Actions
 *
 * Displays a list of actions within a DataTable.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Actions({ rows = [] }) {
  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns;
  }, []);

  return (
    <ErrorHandler location="src/entities/ActionPath/ui/components/tables/Actions/Actions.jsx">
      <TableComponent
        {...{
          columns,
          configuration,
          dataKey: `actionPaths-actions`,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
